var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoKaiperConstruction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 553.43 165.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .logo_kaiper_construction-1 {\n        clip-path: url(#clippath-6);\n      }\n\n      .logo_kaiper_construction-2 {\n        clip-path: url(#clippath-7);\n      }\n\n      .logo_kaiper_construction-3 {\n        clip-path: url(#clippath-4);\n      }\n\n      .logo_kaiper_construction-4 {\n        clip-path: url(#clippath-9);\n      }\n\n      .logo_kaiper_construction-5 {\n        clip-path: url(#clippath-10);\n      }\n\n      .logo_kaiper_construction-6 {\n        stroke-width: .5px;\n      }\n\n      .logo_kaiper_construction-6, .logo_kaiper_construction-7 {\n        stroke: #595959;\n        stroke-miterlimit: 10;\n      }\n\n      .logo_kaiper_construction-6, .logo_kaiper_construction-7, .logo_kaiper_construction-8 {\n        fill: none;\n      }\n\n      .logo_kaiper_construction-7 {\n        stroke-width: .25px;\n      }\n\n      .logo_kaiper_construction-9 {\n        clip-path: url(#clippath-11);\n      }\n\n      .logo_kaiper_construction-10 {\n        clip-path: url(#clippath-1);\n      }\n\n      .logo_kaiper_construction-11 {\n        clip-path: url(#clippath-5);\n      }\n\n      .logo_kaiper_construction-12 {\n        clip-path: url(#clippath-8);\n      }\n\n      .logo_kaiper_construction-13 {\n        clip-path: url(#clippath-3);\n      }\n\n      .logo_kaiper_construction-14 {\n        opacity: .15;\n      }\n\n      .logo_kaiper_construction-15 {\n        clip-path: url(#clippath-12);\n      }\n\n      .logo_kaiper_construction-16 {\n        fill: #595959;\n      }\n\n      .logo_kaiper_construction-17 {\n        clip-path: url(#clippath-2);\n      }\n\n      .logo_kaiper_construction-18 {\n        clip-path: url(#clippath-13);\n      }\n\n      .logo_kaiper_construction-19 {\n        opacity: .05;\n      }\n\n      .logo_kaiper_construction-20 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_construction-8",
    x: 342.62,
    y: 47.43,
    width: 64.32,
    height: 68.54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_construction-8",
    x: 369.97,
    y: 74.07,
    width: 36.98,
    height: 15.27
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_construction-8",
    x: 229.62,
    y: 47.43,
    width: 18.23,
    height: 68.54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_construction-8",
    x: 58.4,
    y: 47.43,
    width: 18.23,
    height: 68.54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_construction-8",
    x: 135.54,
    y: 47.43,
    width: 86.88,
    height: 68.54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_construction-8",
    x: 79.58,
    y: 86.04,
    width: 51.93,
    height: 29.93
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_construction-8",
    x: 79.58,
    y: 47.43,
    width: 51.93,
    height: 29.93
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_construction-8",
    x: 420.68,
    y: 47.43,
    width: 73.06,
    height: 68.54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_construction-8",
    x: 261.86,
    y: 47.43,
    width: 70.78,
    height: 68.54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_construction-8",
    x: 131.51,
    y: 24.67,
    width: 4.03,
    height: 108.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_construction-8",
    x: 222.42,
    y: 24.67,
    width: 7.2,
    height: 108.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_construction-8",
    x: 247.85,
    y: 24.67,
    width: 14,
    height: 108.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_construction-8",
    x: 332.64,
    y: 24.67,
    width: 9.99,
    height: 108.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_construction-8",
    x: 406.95,
    y: 24.67,
    width: 13.73,
    height: 108.74
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "342.62 47.43 342.62 115.98 406.95 115.98 406.95 100.28 360.85 100.28 360.85 63.13 406.95 63.13 406.95 47.43 342.62 47.43"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 369.97,
    y: 74.07,
    width: 36.98,
    height: 15.27
  }))), /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.62,
    y: 47.43,
    width: 18.23,
    height: 68.54
  }))), /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.4,
    y: 47.43,
    width: 18.23,
    height: 68.54
  }))), /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.09,47.43h-28.23l-29.32,68.54h20.16l5.62-13.89h35.32l5.62,13.89h20.16l-29.32-68.54ZM180.69,62.66l9.92,24.55h-23.27l9.93-24.55h3.42Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "131.51 115.98 105.62 115.98 79.58 86.04 104.86 86.04 131.51 115.98"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "131.51 47.43 105.62 47.43 79.58 77.37 104.86 77.37 131.51 47.43"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.74,115.98l-17.08-24.13c8.65-3.29,14.8-11.65,14.8-21.46,0-12.68-10.28-22.96-22.96-22.96h-47.82v68.54h18.23v-22.63h18l14.9,22.63h21.93ZM438.91,63.48h26.67c4.22,0,7.64,3.42,7.64,7.64s-3.42,7.64-7.64,7.64h-26.67v-15.28Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.86,47.43v68.54h18.23v-21.28h28.92c13.05,0,23.63-10.58,23.63-23.63h0c0-13.05-10.58-23.63-23.63-23.63h-47.15ZM280.09,78.65v-15.18h26.73c4.19,0,7.59,3.4,7.59,7.59s-3.4,7.59-7.59,7.59h-26.73Z"
  }))), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-7",
    x1: 438.9,
    y1: 133.41,
    x2: 438.9,
    y2: 24.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-7",
    x1: 420.68,
    y1: 133.41,
    x2: 420.68,
    y2: 24.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-7",
    x1: 280.07,
    y1: 133.41,
    x2: 280.07,
    y2: 24.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-7",
    x1: 261.86,
    y1: 133.41,
    x2: 261.86,
    y2: 24.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-7",
    x1: 247.85,
    y1: 133.41,
    x2: 247.85,
    y2: 24.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-7",
    x1: 229.62,
    y1: 133.41,
    x2: 229.62,
    y2: 24.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-7",
    x1: 360.84,
    y1: 133.41,
    x2: 360.84,
    y2: 24.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-7",
    x1: 342.62,
    y1: 133.41,
    x2: 342.62,
    y2: 24.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-7",
    x1: 58.4,
    y1: 133.41,
    x2: 58.4,
    y2: 24.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-7",
    x1: 76.64,
    y1: 133.41,
    x2: 76.64,
    y2: 24.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-7",
    x1: 32.9,
    y1: 47.43,
    x2: 520.53,
    y2: 47.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-7",
    x1: 32.9,
    y1: 63.49,
    x2: 520.53,
    y2: 63.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-7",
    x1: 32.9,
    y1: 100.27,
    x2: 520.53,
    y2: 100.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-7",
    x1: 494.96,
    y1: 133.41,
    x2: 494.96,
    y2: 24.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-7",
    x1: 406.95,
    y1: 133.41,
    x2: 406.95,
    y2: 24.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-7",
    x1: 332.64,
    y1: 133.41,
    x2: 332.64,
    y2: 24.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-7",
    x1: 222.42,
    y1: 133.41,
    x2: 222.42,
    y2: 24.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-7",
    x1: 131.51,
    y1: 133.41,
    x2: 131.51,
    y2: 24.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-7",
    x1: 135.54,
    y1: 133.41,
    x2: 135.54,
    y2: 24.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-7",
    x1: 32.9,
    y1: 115.98,
    x2: 520.53,
    y2: 115.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-6",
    x1: 58.4,
    y1: 133.41,
    x2: 76.64,
    y2: 133.41
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "logo_kaiper_construction-16",
    points: "67.5 138.78 67.54 138.78 68.53 137.18 69.09 137.18 67.88 139.12 69.09 141.06 68.53 141.06 67.54 139.49 67.5 139.49 66.51 141.06 65.95 141.06 67.19 139.12 65.95 137.18 66.52 137.18 67.5 138.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-6",
    x1: 229.62,
    y1: 133.41,
    x2: 247.85,
    y2: 133.41
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "logo_kaiper_construction-16",
    points: "238.72 138.78 238.75 138.78 239.74 137.18 240.31 137.18 239.1 139.12 240.31 141.06 239.74 141.06 238.75 139.49 238.72 139.49 237.73 141.06 237.16 141.06 238.41 139.12 237.16 137.18 237.74 137.18 238.72 138.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-6",
    x1: 261.86,
    y1: 133.41,
    x2: 280.09,
    y2: 133.41
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "logo_kaiper_construction-16",
    points: "270.96 138.78 270.99 138.78 271.98 137.18 272.55 137.18 271.33 139.12 272.55 141.06 271.98 141.06 270.99 139.49 270.96 139.49 269.97 141.06 269.4 141.06 270.65 139.12 269.4 137.18 269.97 137.18 270.96 138.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-6",
    x1: 342.62,
    y1: 133.41,
    x2: 360.85,
    y2: 133.41
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "logo_kaiper_construction-16",
    points: "351.72 138.78 351.75 138.78 352.74 137.18 353.31 137.18 352.1 139.12 353.31 141.06 352.74 141.06 351.75 139.49 351.72 139.49 350.73 141.06 350.16 141.06 351.41 139.12 350.16 137.18 350.74 137.18 351.72 138.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "logo_kaiper_construction-6",
    x1: 420.68,
    y1: 133.41,
    x2: 438.91,
    y2: 133.41
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "logo_kaiper_construction-16",
    points: "429.78 138.78 429.81 138.78 430.8 137.18 431.37 137.18 430.16 139.12 431.37 141.06 430.8 141.06 429.81 139.49 429.78 139.49 428.79 141.06 428.22 141.06 429.47 139.12 428.22 137.18 428.8 137.18 429.78 138.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_kaiper_construction-7",
    d: "M314.35,71.07c0,4.19-3.39,7.58-7.58,7.58s-7.58-3.39-7.58-7.58,3.39-7.58,7.58-7.58,7.58,3.39,7.58,7.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_kaiper_construction-7",
    d: "M332.64,71.06c0,13.05-10.58,23.64-23.64,23.64s-23.64-10.58-23.64-23.64,10.58-23.64,23.64-23.64,23.64,10.58,23.64,23.64Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "logo_kaiper_construction-7",
    cx: 465.59,
    cy: 71.12,
    r: 7.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_kaiper_construction-7",
    d: "M491.46,70.38c0,12.68-10.28,22.96-22.96,22.96s-22.96-10.28-22.96-22.96,10.28-22.96,22.96-22.96,22.96,10.28,22.96,22.96Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.51,
    y: 24.67,
    width: 4.02,
    height: 108.74
  }))), /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.42,
    y: 24.67,
    width: 7.2,
    height: 108.74
  }))), /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.85,
    y: 24.67,
    width: 14,
    height: 108.74
  }))), /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.64,
    y: 24.67,
    width: 9.99,
    height: 108.74
  }))), /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_construction-18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406.95,
    y: 24.67,
    width: 13.73,
    height: 108.74
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_construction-8",
    width: 553.43,
    height: 165.73
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKaiperConstruction);
export default __webpack_public_path__ + "static/media/logo_kaiper_construction.f8afac090c4e4d5c69d8c36fe60de64f.svg";
export { ForwardRef as ReactComponent };